import { Box, Stack } from '@mui/material'
import React from 'react'
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PaymentsIcon from '@mui/icons-material/Payments';
import PaymentIcon from '@mui/icons-material/Payment';

import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';

import PropaneIcon from '@mui/icons-material/Propane';
import PropaneTankIcon from '@mui/icons-material/PropaneTank';
import { useSelector } from 'react-redux';
import { customStyles } from '../../../styles';
import { CaptionText, RegularText, SubTitle } from '../../helpers';
import { animations } from '../../../utils/animations';

export const ServiceInfo = () => {
  const { trackingOrder } = useSelector(state => state.order)
  const { account, status, type, total  } = trackingOrder
  const { street, colony, extNumber, postalCode } = account
  const { colors: { textColor, main } } = customStyles
  const { slideDown, fadeIn } = animations
  return (
    <Stack spacing={2} className={fadeIn}>
      <Stack direction="row" alignItems="center">
        <HomeRoundedIcon sx={{ marginRight: 3, color: textColor }} />
        <RegularText text={`${street}, #${extNumber}, ${colony}, ${postalCode}`} color={textColor}/>
      </Stack>
      {/* <Stack direction="row">
        <Stack direction="row">
          {}
        </Stack>
      </Stack> */}
      {/* <Stack direction="row" justifyContent="space-between">
        <Stack direction="row">
          <CreditCardIcon sx={{ marginRight: 3, color: textColor }} />
        <RegularText text={`Metodo de pago`} />
        </Stack>
        <RegularText text={`Terminal`} color={textColor}/>
      </Stack> */}
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row">
        {
          type === 'PORTATIL'
          ? <PropaneTankIcon sx={{ marginRight: 3, color: textColor }} />
          : <HomeRoundedIcon sx={{ marginRight: 3, color: textColor }} />
        }
        <RegularText text={`Gas ${type === 'PORTATIL' ? 'Cilindro' : 'Estacionario'}`} bold/>
        </Stack>
        {/* <RegularText text={`18lt test`} color={textColor}/> */}
      </Stack>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <SubTitle text="Total" color={main} bold />
        <SubTitle text={`$ ${total} MXN`} color={main} bold />
      </Stack>
    </Stack>
  )
}
